/**
 * Created by Mark on 19/04/2017.
 */


/**
 * Created by Mark on 17/04/2017.
 */

import React  from 'react';
import Layout from '../components/layouts/standard-page.js';
import TeacherForm from '../components/forms/teacher-form.js';
import TeacherEdit from '../components/forms/teacher-edit-form.js';
import StaffTable from '../components/tables/staff-table.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHead from '../components/card-header.js';
import Modal from 'react-bootstrap/lib/Modal';
import { FormattedMessage } from 'react-intl';
import {  Link , hashHistory } from "react-router";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6
import StaffService from '../services/staff-services.js';
import {Breadcrumb , Button} from "react-bootstrap"
import StaffStore from "../store/staff-store.js";
import AuthneticationStore from "../store/authentication-store.js";

export default class ScoresComponent extends React.Component {

    constructor(props) {
        super();
        this.state = {
            toggleAddUser:false,
            deleteComfirm:false,
            staffMember:{}
        };
        this.handelAddUser = this.handelAddUser.bind(this);
        this.handelCreated = this.handelCreated.bind(this);
    }


    handelCreated(){
        StaffService.getAccountsStaff();
        this.setState({toggleAddUser:false});
    }

    handelAddUser(){
       this.setState({toggleAddUser:!this.state.toggleAddUser});
    }


    getBreadCrumb(){

        return  <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
                <FormattedMessage id={ 'ui-792' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
        </Breadcrumb>
    }

    handleEdit(fields){

        var user = StaffStore.getStaff(fields[0].id);

        if(user === null) return;

        this.setState({editUser:true , staffMember:user});
    }

    handelDelete(fields){

        var user = StaffStore.getStaff(fields[0].id);
        if(user === null) return;
        this.setState({deleteComfirm:true , staffMember:user});
    }

    handleCancelEdit(){
        StaffService.getAccountsStaff();
        this.setState({editUser:false , staffMember:{}});
    }

    deleteObject(){
        StaffService.deleteStaff(this.state.staffMember.uid).then(function(){
            this.handleComfirmExit();
        }.bind(this))
    }

    handleComfirmExit(){
        StaffService.getAccountsStaff();
        this.setState({deleteComfirm:false , staffMember:{}});
    }

    render(){

        let button = [];

        if(AuthneticationStore.hasCreatePermissions())
        {
            button.push()
        }

        return (<Layout>
                    {this.getBreadCrumb()}
                    <Modal show={this.state.editUser} onHide={this.handleCancelEdit.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                        <Modal.Header closeButton>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="p-10">
                                <TeacherEdit  teacher={this.state.staffMember} onCreated={this.handleCancelEdit.bind(this)}/>
                            </div>
                        </Modal.Body>
                    </Modal>
                    <Modal show={this.state.deleteComfirm} onHide={this.handleComfirmExit.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                        <Modal.Header closeButton>
                            <FormattedMessage id={ 'ui-444' } defaultMessage={ 'Delete' }/> {this.state.staffMember.name}
                        </Modal.Header>
                        <Modal.Body>
                            <FormattedMessage id={ 'ui-667' } defaultMessage={ 'Are You Sure' }/>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.handleComfirmExit.bind(this)}><FormattedMessage id={ 'ui-41' } defaultMessage={ 'Cancel' }/></Button>
                            <Button onClick={this.deleteObject.bind(this)} bsStyle="primary"><FormattedMessage id={ 'ui-444' } defaultMessage={ 'Delete' }/></Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.toggleAddUser} onHide={this.handelCreated} bsSize="large" aria-labelledby="contained-modal-title-lg">
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-lg"><FormattedMessage id={ 'ui-907' } defaultMessage={ 'Create Staff Member' }/></Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="p-10">
                                <TeacherForm  onCreated={this.handelCreated}/>
                            </div>
                        </Modal.Body>
                    </Modal>
                    <Card>

                        <CardBody noPadding>
                            <CardHead>
                                <h2>
                                    <FormattedMessage id={ 'ui-792' } defaultMessage={ '' }/>
                                    <small> <FormattedMessage id={ 'ui-2177' } defaultMessage={ 'Assigned Students' }/></small>
                                </h2>
                            </CardHead>


                            <StaffTable
                                handleDelete={AuthneticationStore.hasCreatePermissions() ? this.handelDelete.bind(this) : null }
                                handleEdit={AuthneticationStore.hasCreatePermissions() ? this.handleEdit.bind(this) : null}
                                additionalButtons = {AuthneticationStore.hasCreatePermissions() ? [{icon:'zmdi zmdi-account-add zmdi-hc-fw' , text: <FormattedMessage id={ 'ui-524' } defaultMessage={ 'Add a user' }/>, action:this.handelAddUser}] : false}
                                />

                        </CardBody>
                        <br />
                    </Card>
                </Layout>);
    }
}




// WEBPACK FOOTER //
// ./src/screens/staff-management.js